import React from "react";
// import "./App.css";
function Search() {
    return (
        <div>
            it is search
        </div>
    );
}
export default Search;
